<template>
    <div>
    <p><b>{{this.caption}}</b></p>

    <select id="similar_products" v-model="similar_products">
        <option :value="0">{{ i18n.vyberte }}</option>
        <option v-for="item in products" :value="item.slug[lang]">{{item.name[lang]}}</option>
    </select>

    <hr>
    </div>
</template>

<script>

    export default {
        props: {
            products: Array,
            route: String,
            caption: String
        },
        data() {
            return {
                similar_products: 0,
	              lang: document.documentElement.lang,
                i18n: i18n
            }
        },
        mounted() {
        },
        watch: {
            similar_products(val) {
                if(val != 0) {
                    var url = this.route.replace('/-', '/' + val)
                    window.location.replace(url)
                }
            }
        }
    }

</script>
